export const siteInfo = {
  name: "Kiddie Kingdom",
  phone: "818-818-4270",
  phoneHref: "tel:+18188184270",
  email: "kiddiekingdomplayground@gmail.com",
  address: "19444 Business Center Dr, Northridge, CA 91324",
  directions:
    "https://maps.google.com/?q=19444+Business+Center+Dr,+Northridge,+CA+91324",
  instagram: "https://www.instagram.com/kiddiekingdomplayground/",
  facebook: "https://www.facebook.com/profile.php?id=61571794775625",
  waiver: "https://forms.fillout.com/t/qTow1B64kAus",
  formId: "xdknvawd",
  hours: "10:00 AM – 8:00 PM",
};

export const openPlayPricing = [
  { label: "1st child", price: 30 },
  { label: "2nd child", price: 25 },
  { label: "3rd child", price: 20 },
];

export const membershipPricing = [
  { label: "1st child", price: 250 },
  { label: "2nd child", price: 225 },
  { label: "3rd child", price: 205 },
];
